<template>
    <div>
        <div class="contents">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="breadcrumb-main user-member justify-content-sm-between ">
                            <div class=" d-flex flex-wrap justify-content-center breadcrumb-main__wrapper">
                                <div
                                    class="d-flex align-items-center user-member__title justify-content-center mr-sm-25">
                                    <h4 class="text-capitalize fw-500 breadcrumb-title">Google Form Script Generator</h4>
                                    <button type="button" class="btn btn-sm btn-info text-white ml-3" @click="showTutorial = true">
                                        <i class="fas fa-graduation-cap"></i> Tutorial
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-4">
                        <div class="userDatatable global-shadow border p-30 bg-white radius-xl w-100 mb-30">
                            <form v-on:submit.prevent="saveAutoreply">
                                <div class="custom-control custom-switch mb-2">
                                    <input type="checkbox" class="custom-control-input" id="useRotatorSwitch" v-model="useRotator">
                                    <label class="custom-control-label" for="useRotatorSwitch">
                                        <b>🔀 Aktifkan Device Rotator</b>
                                        <span class="badge badge-success ml-1">ANTI-BANNED 🛡️</span>
                                    </label>
                                </div>
                                <small class="text-muted d-block mb-2">
                                    Saat aktif, tiap submit form akan dikirim dari device yang dipilih secara <b>acak/bergantian</b> — biar beban terbagi & aman dari banned.
                                </small>

                                <!-- SINGLE DEVICE MODE -->
                                <template v-if="!useRotator">
                                    <label> Device </label>
                                    <select v-model="form.device" class="form-control" @change="deviceSelect()">
                                        <option value="" selected disabled>== PILIH DEVICE ==</option>
                                        <option v-for="d in device" :key="d.id" :value="d.device_key">{{ d.name }}</option>
                                    </select>
                                </template>

                                <!-- ROTATOR MODE: multi device -->
                                <template v-else>
                                    <label>Pilih Device untuk Rotasi <span class="text-muted">(centang min. 2)</span></label>
                                    <div class="rotator-device-list">
                                        <div v-for="d in device" :key="d.id" class="custom-control custom-checkbox">
                                            <input type="checkbox" class="custom-control-input" :id="'rot-dev-'+d.id"
                                                :checked="selectedDeviceKeys.includes(d.device_key)" @change="toggleRotatorDevice(d.device_key)">
                                            <label class="custom-control-label" :for="'rot-dev-'+d.id">
                                                {{ d.name }}
                                                <span class="badge" :class="d.status === 'connected' ? 'badge-success' : 'badge-secondary'">{{ d.status }}</span>
                                            </label>
                                        </div>
                                    </div>
                                    <small class="text-success d-block mt-1"><b>{{ selectedDeviceKeys.length }}</b> device dipilih untuk rotasi</small>
                                </template>
                                <hr>
                                <label>List Field Google Form</label>
                                <br>
                                <button type="button" class="btn btn-sm btn-success margin-5" @click="addField">Tambah Field</button>
                                <button type="button" class="btn btn-sm btn-danger margin-5"  @click="deleteField">Hapus Field</button>
                                <br>
                                <div v-for="(f, index) in field" v-bind:key="index">
                                    <br>
                                    <label for="">Field {{ index + 1 }}</label>
                                    <input type="text" v-model="f.value" class="form-control">
                                </div>
                                <hr>
                                <label>List Pesan</label>
                                <br>
                                <button type="button"  class="btn btn-sm btn-success margin-5" @click="addMessage">Tambah Pesan</button>
                                <button type="button"  class="btn btn-sm btn-danger margin-5" @click="deleteMessage">Hapus Pesan</button>
                                <br>
                                <div v-for="(p, idx) in pesan" v-bind:key="'pesan'+idx">
                                    <br>
                                    <label for="">Tujuan</label>
                                    <input type="text" v-model="tujuan[p.index].value" class="form-control">
                                    <br>
                                    <label for="">Pesan</label>
                                    <CustomTextArea v-model="pesan[p.index].value"></CustomTextArea>
                                </div>
                                <br>
                                <i>* Pakai [] untuk memanggil isi field; contoh [Nomor Whatsapp]</i>
                            </form>
                        </div>
                    </div>
                    <div class="col-lg-8">
                        <div class="userDatatable global-shadow border p-30 bg-white radius-xl w-100 mb-30">
                            <h3 style="text-align: center;">Google Script</h3>
                            <br>
                            <highlightjs javascript :code="finalCode"/>
                            <button v-on:click="copyCode" class="btn btn-success btn-block">Copy</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- TUTORIAL MODAL -->
        <div v-if="showTutorial" class="gf-modal-backdrop" @click.self="showTutorial = false">
            <div class="gf-modal">
                <div class="gf-modal-head">
                    <h4 style="margin:0"><i class="fas fa-graduation-cap"></i> Tutorial Otomasi Google Form + Device Rotator</h4>
                    <button class="gf-close" @click="showTutorial = false">&times;</button>
                </div>
                <div class="gf-modal-body">
                    <div class="gf-banner">
                        <h5 style="margin:0;color:#fff">📋 Kirim WA Otomatis dari Google Form</h5>
                        <p style="margin:6px 0 0;font-size:13px">Setiap ada yang isi Google Form, customer otomatis dapat pesan WhatsApp. Tambah <b>Device Rotator</b> biar pengiriman dibagi ke beberapa nomor WA = <b>anti-banned</b>.</p>
                    </div>

                    <div class="gf-step">
                        <div class="gf-step-head"><span class="gf-num">1</span> Pilih Mode Pengiriman</div>
                        <p><b>Tanpa Rotator:</b> semua pesan dikirim dari 1 device.<br>
                        <b>Dengan Device Rotator (disarankan):</b> centang toggle <b>"Aktifkan Device Rotator"</b>, lalu pilih <b>minimal 2 device</b>. Tiap submit form akan dikirim dari device yang dipilih secara <b>acak bergantian</b>.</p>
                    </div>

                    <div class="gf-step">
                        <div class="gf-step-head"><span class="gf-num">2</span> Isi Field & Pesan</div>
                        <p>• <b>List Field:</b> tulis nama kolom Google Form Kakak persis (mis. <code>Nomor Whatsapp</code>, <code>Nama</code>).<br>
                        • <b>Tujuan:</b> isi <code>[Nomor Whatsapp]</code> (pakai kurung siku untuk panggil isi field).<br>
                        • <b>Pesan:</b> tulis pesan, panggil field dengan <code>[Nama]</code>, dll.</p>
                    </div>

                    <div class="gf-step">
                        <div class="gf-step-head"><span class="gf-num">3</span> Copy Script</div>
                        <p>Klik tombol <b>Copy</b> di kanan untuk menyalin kode Google Apps Script yang sudah otomatis ter-generate.</p>
                    </div>

                    <div class="gf-step">
                        <div class="gf-step-head"><span class="gf-num">4</span> Pasang di Google Form</div>
                        <p>1. Buka <b>Google Form</b> Kakak → klik titik tiga (⋮) → <b>Script editor</b><br>
                        2. <b>Hapus</b> kode bawaan, <b>paste</b> kode dari StarSender<br>
                        3. Klik <b>Save</b> 💾</p>
                    </div>

                    <div class="gf-step">
                        <div class="gf-step-head"><span class="gf-num">5</span> Pasang Trigger (WAJIB)</div>
                        <p>1. Di Script editor → menu <b>Triggers</b> (ikon jam ⏰) → <b>Add Trigger</b><br>
                        2. Setting: Function = <b>starsender</b>, Event source = <b>From form</b>, Event type = <b>On form submit</b><br>
                        3. Save → izinkan akses (Authorize) ✅</p>
                    </div>

                    <div class="gf-warn">
                        <b>⚠️ Tips Anti-Banned:</b> Pakai Device Rotator dengan 2-3 nomor WA, dan pastikan semua device <b>connected</b>. Untuk volume tinggi, beri jeda & variasi isi pesan (Spintax).
                    </div>

                    <div class="gf-success">
                        ✅ Selesai! Sekarang setiap ada submit Google Form, customer otomatis dapat pesan WhatsApp — dibagi rata ke device yang Kakak pilih.
                    </div>
                </div>
                <div class="gf-modal-foot">
                    <button class="btn btn-primary" @click="showTutorial = false">Mengerti, Tutup</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CustomTextArea from "@/components/module/CustomTextarea.vue";

    export default {
        components: {
            CustomTextArea,
        },
        data() {
            return {
                device: [],
                form: {
                    device: "",
                },
                useRotator: false,
                selectedDeviceKeys: [],
                showTutorial: false,
                apikey: "",
                variable: "",
                tujuanFinal: "",
                pesanFinal: "",
                field: [],
                tujuan: [],
                pesan: [],
                randomStringStorage: [],
                finalCode: ""
            };
        },
        watch: {
            apikey: {
                handler(){
                    this.setFinalCode()
                },
                deep: true
            },
            useRotator(){
                this.setFinalCode()
            },
            selectedDeviceKeys:{
                handler(){
                    this.setFinalCode()
                },
                deep: true
            },
            field:{
                handler(val){
                    this.variable = ""
                    for(let i = 0;i < val.length;i++){
                        if(!val[i].value) continue
                        if(i > 0){
                            this.variable += `
    `
                        }

                        if(!this.randomStringStorage[i]) this.randomStringStorage[i] = this.randomString(5)
                        this.variable += "var " + this.randomStringStorage[i] + ` = event.namedValues["`+ val[i].value +`"][0];`
                    }

                    this.setFinalCode()
                },
                deep: true 
            },
            tujuan:{
                handler(val){
                    this.tujuanFinal = ""
                    let dummy = []

                    for(let i = 0;i < val.length;i++){
                        if(!val[i].value) continue
                        if(val[i].value.startsWith("[") && val[i].value.endsWith("]") && this.searchVariable(val[i].value)){
                            dummy.push(this.searchVariable(val[i].value))
                        }else{
                            if(this.ValidateNumber(val[i].value)){
                                dummy.push(`"`+ val[i].value +`"`)
                            }
                        }
                    }

                    let inc = 0
                    for(let i = 0;i < dummy.length;i++){
                        if(dummy[i]){
                            if(inc > 0){
                                this.tujuanFinal += ', '
                            }
                            this.tujuanFinal += dummy[i]
                            inc++
                        }
                    }

                    this.setFinalCode()
                },
                deep: true 
            },
            pesan:{
                handler(val){
                    this.pesanFinal = ""
                    let dummy = []

                    for(let i = 0;i < val.length;i++){
                        if(!val[i].value) continue
                        dummy.push("`" + this.findVariableInMessage(val[i].value) + "`")
                    }

                    let inc = 0
                    for(let i = 0;i < dummy.length;i++){
                        if(dummy[i]){
                            if(inc > 0){
                                this.pesanFinal += ', '
                            }
                            this.pesanFinal += dummy[i]
                            inc++
                        }
                    }

                    this.setFinalCode()
                },
                deep: true 
            }
        },
        mounted() {
            this.getDevice({ status: "all" })
            
            this.setFinalCode()
            //this.variable = `test: event.namedValues["Nomor"][0];,\n        test: event.namedValues["Nomor"][0],`
        },
        methods: {
            async getDevice(param) {
                let res = await this.$store.dispatch("device_list_all", param);
                this.device = res.data.data.devices
            },
            deviceSelect(){
                this.apikey = this.form.device
            },
            toggleRotatorDevice(key){
                const i = this.selectedDeviceKeys.indexOf(key)
                if(i === -1){
                    this.selectedDeviceKeys.push(key)
                }else{
                    this.selectedDeviceKeys.splice(i, 1)
                }
            },
            addField(){
                this.field.push({
                    index: this.field.length,
                    value: ""
                })
            },
            deleteField(){
                this.field.splice(-1)
            },
            addMessage(){
                this.tujuan.push({
                    index: this.tujuan.length,
                    value: ""
                })
                this.pesan.push({
                    index: this.pesan.length,
                    value: ""
                })
            },
            deleteMessage(){
                this.tujuan.splice(-1)
                this.pesan.splice(-1)
            },
            searchVariable(searchVal){
                for(let i = 0;i < this.field.length;i++){
                    searchVal = searchVal.replaceAll("[", "")
                    searchVal = searchVal.replaceAll("]", "")
                    if(searchVal== this.field[i].value){
                        return this.randomStringStorage[i]
                    }
                }
                return ""
            },
            findVariableInMessage(msg){
                for(let i = 0;i < this.field.length;i++){
                    let search = "[" + this.field[i].value + "]"
                    msg = msg.replaceAll(search, "` + " + this.randomStringStorage[i] + " + `")
                }
                return msg
            },
            copyCode(){
                navigator.clipboard.writeText(this.finalCode)
                this.$toast.success("Kode berhasil di copy")
            },
            setFinalCode(){
                let apiKeyBlock = ""
                if(this.useRotator){
                    // Device Rotator: random pick salah satu device key tiap submit (anti-banned)
                    let keysArr = this.selectedDeviceKeys.map(k => '"' + k + '"').join(", ")
                    apiKeyBlock = `var APIKeys = [` + keysArr + `];
    var APIKey = APIKeys[Math.floor(Math.random() * APIKeys.length)];`
                }else{
                    apiKeyBlock = `var APIKey = "` + this.apikey + `";`
                }
                this.finalCode = `function starsender(event){
    ` + apiKeyBlock + `
    var url = "https://api.starsender.online/api/send";
    ` + this.variable + `

    var tujuan = [` + this.tujuanFinal + `];
    var pesan = [` + this.pesanFinal + `];

    for (var i = 0; i < tujuan.length; i++) {
        if(!pesan[i] || !tujuan[i]) continue;

        var payload = {
            "messageType": "text",
            "body": pesan[i],
            "to": tujuan[i]
        };

        var response = UrlFetchApp.fetch(url, {
            "method": "post",
            "headers": {
                "Authorization": APIKey
            },
            "payload": JSON.stringify(payload)
        });
        
        Logger.log(response.getContentText());
    }
}
            `
            },
            randomString(length) {
                let result           = '';
                let characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
                let charactersLength = characters.length;
                for ( let i = 0; i < length; i++ ) {
                    result += characters.charAt(Math.floor(Math.random() * charactersLength));
                }

                return result;
            },
            ValidateNumber(strNumber) {
                var regExp = new RegExp("^\\d+$");
                var isValid = regExp.test(strNumber); // or just: /^\d+$/.test(strNumber);
                return isValid;
            }
        },
    };
</script>

<style scoped>

    .thick-border{
        border: 2px solid #6c6c6c !important;
    }

    .margin-5{
        margin: 5px;
    }

    hr{
        margin-top: 15px;
        margin-bottom: 15px;
    }

    .rotator-device-list{
        max-height: 220px;
        overflow-y: auto;
        border: 1px solid #e9ecef;
        border-radius: 8px;
        padding: 10px;
        background: #fafbfc;
    }
    .rotator-device-list .custom-checkbox{ margin-bottom: 6px; }

    .gf-modal-backdrop{
        position: fixed; top:0; left:0; width:100vw; height:100vh;
        background: rgba(0,0,0,.6); z-index: 10600;
        display:flex; align-items:center; justify-content:center; padding:1rem;
    }
    .gf-modal{
        background:#fff; border-radius:12px; max-width:640px; width:100%;
        max-height:88vh; display:flex; flex-direction:column; overflow:hidden;
        box-shadow:0 10px 40px rgba(0,0,0,.3);
    }
    .gf-modal-head{
        display:flex; justify-content:space-between; align-items:center;
        padding:16px 20px; border-bottom:1px solid #e9ecef; background:#f8f9fa;
    }
    .gf-close{ background:none; border:none; font-size:26px; line-height:1; cursor:pointer; color:#888; }
    .gf-modal-body{ padding:20px; overflow-y:auto; }
    .gf-modal-foot{ padding:14px 20px; border-top:1px solid #e9ecef; text-align:right; background:#f8f9fa; }
    .gf-banner{
        background:linear-gradient(135deg,#007bff,#0056b3); color:#fff;
        padding:16px; border-radius:10px; margin-bottom:16px;
    }
    .gf-step{ margin-bottom:16px; }
    .gf-step-head{ font-weight:600; margin-bottom:6px; font-size:15px; color:#333; }
    .gf-num{
        display:inline-flex; align-items:center; justify-content:center;
        width:24px; height:24px; border-radius:50%; background:#007bff; color:#fff;
        font-size:13px; margin-right:8px;
    }
    .gf-step p{ font-size:13px; color:#555; margin:0; line-height:1.6; }
    .gf-step code{ background:#f1f3f5; padding:1px 6px; border-radius:4px; color:#e83e8c; font-size:12px; }
    .gf-warn{ background:#fff8e1; border-left:4px solid #ffc107; padding:12px 14px; border-radius:6px; font-size:13px; margin:14px 0; }
    .gf-success{ background:#e9f9ef; border-left:4px solid #28a745; padding:12px 14px; border-radius:6px; font-size:13px; }
</style>